"use client";

import DocumentParseSidebar from "./DocumentParseSidebar";
import OcrConfigSidebar from "./OcrConfigSidebar";
import { EndpointType } from "../../../constants/Endpoints";

export { ConfigSidebarDisabledInfoTooltip } from "./ConfigSidebarComponents";
export { ConfigSidebarLayout } from "./ConfigSidebarLayout";
export { useConfigSidebar } from "./useConfigSidebar";

export default function ConfigSidebar({
  isOpen,
  onClose,
  className,
  endpointType,
}: {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  endpointType: EndpointType;
}) {
  if (endpointType === "ocr") {
    return (
      <OcrConfigSidebar
        isOpen={isOpen}
        onClose={onClose}
        className={className}
        endpointType={endpointType}
      />
    );
  }
  if (endpointType === "layout-analysis") {
    return (
      <DocumentParseSidebar
        isOpen={isOpen}
        onClose={onClose}
        className={className}
        endpointType={endpointType}
      />
    );
  }

  return null;
}
